import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { RepaymentSchedule } from './RepaymentSchedule';
import { EarningSchedule } from './EarningSchedule';
import { useGetAllocatedRepaymentSchedule } from '@/query/queries/investing/useGetAllocatedRepaymentSchedule';
import { useGetFundraisingDates } from '@/query/queries/investing/useGetFundraisingDates';
import { UnderlinedTabs } from '@scramble/ui';

const TABS = {
  earnings: 'earnings',
  repayments: 'repayments',
};

export const EarningsAndRepayments = () => {
  const { data: fundraisingDates } = useGetFundraisingDates();
  const activeFundraisingId =
    fundraisingDates?.is_active && fundraisingDates?.id;
  const { data } = useGetAllocatedRepaymentSchedule(activeFundraisingId);
  const { t } = useTranslation();
  const [tab, setTab] = useState(TABS.earnings);

  return (
    <div>
      <UnderlinedTabs selected={tab} onChange={value => setTab(value)}>
        <UnderlinedTabs.Tab value={TABS.earnings}>
          {t('investing:earn_rep_schedule.earnings')}
        </UnderlinedTabs.Tab>
        <UnderlinedTabs.Tab value={TABS.repayments}>
          {t('investing:earn_rep_schedule.repayments')}
        </UnderlinedTabs.Tab>
      </UnderlinedTabs>
      {tab === TABS.earnings && <EarningSchedule data={data} />}
      {tab === TABS.repayments && <RepaymentSchedule data={data} />}
    </div>
  );
};
